import { render, staticRenderFns } from "./AppointmentEditAppBar.vue?vue&type=template&id=a28ebc36"
import script from "./AppointmentEditAppBar.vue?vue&type=script&lang=ts"
export * from "./AppointmentEditAppBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports